import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import ProjectCreationForm from './ProjectCreationForm.vue'
import VsButton from '@/components/vision/VsButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCreationSection',
  emits: ['save'],
  setup(__props, { emit }) {



const showCreateProjectForm = ref(true)

const save = (projectName: string) => {
  emit('save', projectName)
}

const toggleCreateProjectForm = (show: boolean) => {
  showCreateProjectForm.value = show
}

return { __sfc: true,emit, showCreateProjectForm, save, toggleCreateProjectForm, ProjectCreationForm, VsButton }
}

})